<template>
  <mega-table v-if="items.length" title="Invoice Details" :items="items" :fields="fields" :showDetails="false" />
</template>

<script>
import { invoices } from '@youwish1/api-package'
import MegaTable from '../../components/MegaTable'
import { formatMoney, formatDate } from '../page-helpers'

export default {
  name: 'InvoiceDetails',
  components: { MegaTable },
  props: { invoice: { type: Object } },
  data() {
    return { items: [] }
  },
  computed: {
    fields() {
      return [
        { key: 'order_id', label: 'Order ID', sortable: false },
        { key: 'product_name', label: 'Product', sortable: false },
        { key: 'voucher_code', label: 'Voucher', sortable: false },
        { key: 'price', label: 'Sold for', sortable: false, formatter: value => formatMoney(value) },
        { key: 'commission', label: 'Commission', sortable: false, formatter: value => formatMoney(value) },
        { key: 'vat', label: 'VAT', sortable: false, formatter: value => formatMoney(value) },
        { key: 'created_at', label: 'Created At', sortable: false, formatter: value => formatDate(value) },
        { key: 'experienced_at', label: 'Experienced At', sortable: false },
      ]
    },
  },
  mounted() {
    this.loadContent()
  },
  methods: {
    async loadContent() {
      const details = await invoices.details(this.invoice.id)
      this.items = details.data()
      this.$emit('loaded')
    },
  },
}
</script>
